export default __webpack_public_path__ + "static/media/Amanda_Baroni___Elementos_da_Minha_Natureza__12.fdce3f96.jpg";